import React, { FC, InputHTMLAttributes } from 'react';

const defaultProps = {
  className: undefined,
};

const Toggler: FC<InputHTMLAttributes<HTMLInputElement> & { label?: string }> = (props) => {
  return <input {...props} id={props.label} type="checkbox" />;
};

Toggler.defaultProps = defaultProps;

export default Toggler;
